import {useCallback, useEffect, useRef, useState} from 'react';
import {toast} from 'react-toastify';
import {t} from '@lingui/core/macro';

export const TEST_NOTIFY_LOCK_MS = 60 * 1000;

type SendResult = {data?: unknown, error?: unknown};

const getMessage = (data: unknown): string => (
    typeof data === 'object' && data !== null && 'message' in data && typeof data.message === 'string'
        ? data.message
        : ''
);

export const useTestNotify = (active: boolean, send: () => Promise<SendResult>) => {
    const [sending, setSending] = useState(false);
    const [locked, setLocked] = useState(false);
    const timer = useRef<ReturnType<typeof setTimeout>>();

    useEffect(() => () => clearTimeout(timer.current), []);

    const onSend = useCallback(async() => {
        if (!active || sending || locked) return;

        setSending(true);
        const result = await send();
        if (!('error' in result)) {
            toast.info(getMessage(result.data) || t`Уведомление отправлено`);
        }
        setSending(false);
        setLocked(true);
        timer.current = setTimeout(() => setLocked(false), TEST_NOTIFY_LOCK_MS);
    }, [active, sending, locked, send]);

    return {
        sending,
        disabled: !active || locked,
        onSend,
    };
};

export default useTestNotify;
